<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" headerClasses="pb-0" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Bank Details</h3>
        <div class="border rounded p-3" style="background: #F6F9FD;" v-if="bank">
            <b-row>
                <b-col cols="12" md="4" class="border-right">
                    <el-image
                        style="height: 100px"
                        :src="bank.bank_image_url"
                        fit="contain"
                    >
                        <template #error>
                            <div class="image-slot">
                                <span class="d-block">{{ bank.bank_name }}</span>
                            </div>
                        </template>
                    </el-image>
                    <h4>Eligible Amount</h4>
                    <p class="text-xs text-muted">Preapproved</p>
                    <p class="font-weight-600 mb-2">RM {{ bank.bank_loan_eligibility_amount | moneyFormatter }}</p>
                    <p class="text-xs text-muted">Estimated Interest Rate</p>
                    <p class="font-weight-600">{{bank.bank_loan_interest_rate}}% p.a</p>
                </b-col>
                <b-col cols="12" md="8">
                    <p class="font-weight-600">Benefits:</p>
                    <ul>
                        <li>Up to {{ bank.bank_loan_tenure_year }} Years of Tenure</li>
                        <li>Floating Interest Rate</li>
                        <li>Up to 90% Margin of Finance</li>
                        <li>Term Loan</li>
                        <li>3 Years Lock-in Period</li>
                        <li>Low Requirements</li>
                        <li>Low Repayment Rate</li>
                        <li>Low Minimum Age</li>
                        <li>Full Flexi Packages</li>
                        <li>Zero Entry Package Cost</li>
                    </ul>
                </b-col>
            </b-row>
        </div>
    </modal>
</template>
<style>
.el-image .image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: 15px;
}
</style>
<script>
import Modal from "@/components/Modal"
import { Image } from 'element-ui'


export default {
    props:{
        show_bank_details: Boolean,
        bank: Object
    },
    components: {
        Modal,
        [Image.name]: Image,
    },
    computed: {
        show: {
            get() {
                return this.show_bank_details;
            },
            set(newVal) {
                this.$emit('update:show_bank_details', newVal);
            },
        },
    }
}
</script>